import { IRole } from "./IRole";

export interface IUser {
  id: number;
  iat: number;
  identifier: string;
  roles: IRole[];
  password: string;
  enabled: boolean;
  email?: string | null;
  emailNotifications?: boolean;
}

export interface IUserMinimal {
  id: number;
  identifier: string;
}

export interface IUserEdit {
  id?: number;
  identifier: string;
  password: string;
  enabled: boolean;
  email?: string | null;
  emailNotifications?: boolean;
}

// Modifica di alcuni campi di un utente esistente (email, notifiche)
export interface IUserFieldsEdit {
  id: number;
  email?: string | null;
  emailNotifications?: boolean;
}

// Stessa regola del server: nome@dominio.tld, senza spazi
export const EMAIL_RE = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]{2,}$/;
export const emailError = (v?: string | null): string | undefined =>
  v && v.trim() !== "" && (v.trim().length > 254 || !EMAIL_RE.test(v.trim()))
    ? "Indirizzo email non valido"
    : undefined;

// Email di un utente: uno o piu' indirizzi separati da virgola, al massimo 5, ognuno controllato (come il server)
export const MAX_USER_EMAILS = 5;
export const emailListError = (v?: string | null): string | undefined => {
  const list = (v ?? "").split(/[,;]/).map((x) => x.trim()).filter(Boolean);
  if (!list.length) return undefined;
  const bad = list.find((e) => e.length > 254 || !EMAIL_RE.test(e));
  if (bad) return `Indirizzo email non valido: ${bad}`;
  if (new Set(list.map((e) => e.toLowerCase())).size > MAX_USER_EMAILS) return `Al massimo ${MAX_USER_EMAILS} indirizzi`;
  return undefined;
};
